import COLORS from '@/constants/colors';

export default {
  link: {
    display: 'flex',
    fontWeight: 600,
    alignItems: 'center',
    color: COLORS.mercanto_blue,
    padding: '9px 8px',
    textDecoration: 'none',
    borderRadius: '6px',
    horizontal: {
      fontSize: '16px',
      fontWeight: 500,
      padding: '14px 28px',
      letterSpacing: '-0.2px',
    },
  },
  label: {
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: '25px',
    withIcon: {
      ml: '12px',
    },
  },
};
